import axios from "axios";

const checkStatus = async (
  jobId: string,
  userAuthToken: string,
  handleError: () => void,
  handleState: (state: string) => void
) => {
  return axios({
    method: "get",
    url: `${process.env.REACT_APP_NFT_API_URL}dolby/status`,
    headers: {
      Authorization: `Bearer ${userAuthToken}`,
      "x-jobId": jobId,
    },
  })
    .then((res) => {
      handleState(`Mastering in progress: ${res.data.progress}%`);
      return res.data.progress;
    })
    .catch((er) => {
      handleError();
      return er;
    });
};

const prepareMedia = async (
  userAuthToken: string,
  handleError: () => void,
  handleState: (state: string) => void,
  selectedPreset: string,
  inputUrl: string,
  uuid: string,
  sliderValue: number
) => {
  try {
    handleState(`uploading master metadata...`);
    const data = {
      preset: selectedPreset[0],
      loudness: sliderValue,
      uuid: uuid,
      inputUrl: inputUrl,
    };
    const response = await axios.post(
      `${process.env.REACT_APP_NFT_API_URL}dolby/jobId`,
      data,
      {
        headers: {
          Authorization: `Bearer ${userAuthToken}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    handleState("mastering in progress: 0%");
    return response.data;
  } catch (error) {
    handleError();
    return error;
  }
};

export const handleDolbyEffect = async (
  userAuthToken: string,
  handleError: () => void,
  setMasteredMusicUrl: (url: string) => void,
  setPreviewLoading: (loading: boolean) => void,
  handleState: (state: string) => void,
  selectedPreset: string,
  inputUrl: string,
  uuid: string,
  sliderValue: number
): Promise<void> => {
  prepareMedia(
    userAuthToken,
    handleError,
    handleState,
    selectedPreset,
    inputUrl,
    uuid,
    sliderValue
  ).then(async ({ jobId, destinationUrl }) => {
    if (jobId) {
      try {
        let progress = await checkStatus(
          jobId,
          userAuthToken,
          handleError,
          handleState
        );
        const checkStatusInterval = setInterval(async () => {
          if (progress !== 100) {
            if (progress.message) {
              clearInterval(checkStatusInterval);
            }
            handleState(`Mastering in progress: ${progress}%`);
            progress = await checkStatus(
              jobId,
              userAuthToken,
              handleError,
              handleState
            );
          } else if (progress === 100) {
            clearInterval(checkStatusInterval);
            setMasteredMusicUrl(destinationUrl);
            setPreviewLoading(false);
          }
        }, 1000);
      } catch (error) {
        console.log(error);
      }
    }
  });
};

// Preview section

const checkPreviewStatus = async (
  jobId: string,
  userAuthToken: string,
  handleError: () => void,
  handlePreviewState: (state: string) => void
) => {
  return axios({
    method: "get",
    url: `${process.env.REACT_APP_NFT_API_URL}dolby/preview/status`,
    headers: {
      Authorization: `Bearer ${userAuthToken}`,
      "x-jobId": jobId,
    },
  })
    .then((res) => {
      handlePreviewState(
        `mastering preview in progress: ${res.data.progress}%`
      );
      return res.data.progress;
    })
    .catch((er) => {
      handleError();
      return er;
    });
};

const preparePreviewMedia = async (
  userAuthToken: string,
  handleError: () => void,
  handlePreviewState: (state: string) => void,
  selectedPresetArray: string[],
  inputUrl: string,
  uuid: string,
  sliderValue: number,
  previewStartValue: number | undefined,
  duration: number | undefined
) => {
  try {
    handlePreviewState(`uploading preview master metadata...`);
    const formData = new FormData();

    const response = await axios.post(
      `${process.env.REACT_APP_NFT_API_URL}dolby/preview/jobId`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${userAuthToken}`,
          "Content-Type": "multipart/form-data",
          "x-preset": selectedPresetArray.join(","),
          "x-loudness": sliderValue,
          "x-uuid": uuid,
          "x-inputurl": inputUrl,
          "x-previewstartvalue": previewStartValue,
          "x-duration": duration,
        },
      }
    );
    handlePreviewState("mastering preview in progress: 0%");
    return response.data;
  } catch (error) {
    handleError();
    return error;
  }
};
export const handleDolbyPreviewEffect = async (
  userAuthToken: string,
  handleError: () => void,
  setPreviewUrl: (url: Map<string, string>) => void,
  setPreviewLoading: (loading: boolean) => void,
  handlePreviewState: (state: string) => void,
  selectedPresetArray: string[],
  inputUrl: string,
  uuid: string,
  sliderValue: number,
  previewStartValue: number | undefined,
  duration: number | undefined
): Promise<void> => {
  preparePreviewMedia(
    userAuthToken,
    handleError,
    handlePreviewState,
    selectedPresetArray,
    inputUrl,
    uuid,
    sliderValue,
    previewStartValue,
    duration
  ).then(async ({ jobId, destinationUrlMap }) => {
    if (jobId) {
      try {
        let progress = await checkPreviewStatus(
          jobId,
          userAuthToken,
          handleError,
          handlePreviewState
        );

        const checkPreviewStatusInterval = setInterval(async () => {
          if (progress !== 100) {
            if (progress.message) {
              clearInterval(checkPreviewStatusInterval);
            }
            handlePreviewState(`Mastering preview in progress: ${progress}%`);
            progress = await checkPreviewStatus(
              jobId,
              userAuthToken,
              handleError,
              handlePreviewState
            );
          } else if (progress === 100) {
            clearInterval(checkPreviewStatusInterval);
            setPreviewUrl(new Map(Object.entries(destinationUrlMap)));
            setPreviewLoading(false);
          }
        }, 1000);
      } catch (error) {
        console.log(error);
      }
    }
  });
};

export default handleDolbyEffect;
